export type StatisticsState = {
    locales: Array<string>
}

export const statisticsState: StatisticsState = {
    locales: []
}
